import {combineReducers} from 'redux';

import {SelectionSliceFor} from '../../../store/SelectionSliceFor';

const entityKey = 'certificates';

const selectionSlice = SelectionSliceFor(entityKey);

export const {
    addToSelection,
    removeFromSelection,
    clearSelection,
} = selectionSlice.actions;

// FNP-1300 — SELECTION MOVES INTO REDUX, replacing the module-scoped
// `let globalSelection` + listener `Set` this module used to carry. Third and
// last instance of the anti-pattern FNP-951 retired elsewhere; zones and
// dns-records were FNP-1293.
//
// The old store lived outside React, so it survived unmount and route changes:
// an operator who ticked a certificate, navigated away and came back found the
// checkbox still ticked against a table that had refetched. It also outlived a
// test case, which is why it needed a `resetCertificatesSelection` export for
// the suite to call by hand. A slice needs neither — `setupStore` builds a
// fresh one per render, so isolation is structural rather than remembered.
//
// ⚠️ THE FULL CERTIFICATE IS THE VALUE, not a bare id. The delete confirmation
// names the certificate and lists what it covers, and the in-use refusal needs
// those covered names to explain what would have gone offline. Storing ids
// would mean looking each one up again to say anything useful.
export const CertificatesReducer = combineReducers({
                                                       selection: selectionSlice.reducer,
                                                   });
